import React, { FC } from 'react';

import { TableCell } from '@material-ui/core';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import ViewIcon from '../../../../../assets/icons/ViewIcon';
import { IconButton } from '../../../../../components/UI/IconButton';
import { colorsPalette } from '../../../../../theme';
import { CellProps } from '../../../const';
import useStyles from '../styles';

const ViewDetailsCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const viewDetails = row?.viewDetails;

  return (
    <TableCell key={k} className={cx(styles.contentCell, styles.iconCell)} align={align}>
      <IconButton
        icon={<ViewIcon color={colorsPalette.primary} className={classes.viewDetailsIcon} />}
        label={t('page.assignedLearnings.viewDetails')}
        onClick={viewDetails}
        data-testid="detailsButton"
      />
    </TableCell>
  );
};

export default ViewDetailsCell;
